// import logo from './logo.svg';
import './App.css';
// import MyCounter from './Components/MyCounter';
import CounterContextProider from './Context/CounterContext';
import Header from './Components/header/Header';
import Particles from "react-tsparticles";
import Greeting from './Components/greeting/Greeting';
import Apod from './Components/Apod/Apod';
// import Birthday from './Components/Birthday/Birthday';
import Earth from './Components/Earth/Earth';
import Donki from './Components/Donki/Donki';
import Gallary from './Components/Gallary/Gallary';
import Contact from './Components/contact/Contact';
import Feedback from './Components/Feedback/Feedback';
// import Slider from './Components/Slider/Slider';



function Home() {
  return (
    <CounterContextProider>
    <Header />

    <div className="App">
    <div style={{ position: 'absolute'}}>
        
      
    <Particles
    height="600px"
     width="97vw"
     background="black"
        id="tsparticles"
        
        options={{
          "background": "black",
          fpsLimit: 60,
  particles: {
    number: {
      value: 88,
      density: {
        enable: true,
        value_area: 700
      }
    },
    color: {
      value: ["#aa73ff", "#f8c210", "#83d238", "#33b1f8"]
    },
    shape: {
      type: "circle",
      stroke: {
        width: 0,
        color: "#000000"
      },
      polygon: {
        nb_sides: 15
      }
    },
    opacity: {
      value: 0.5,
      random: false,
      anim: {
        enable: false,
        speed: 1.5,
        opacity_min: 0.15,
        sync: false
      }
    },
    size: {
      value: 2.5,
      random: false,
      anim: {
        enable: true,
        speed: 2,
        size_min: 0.15,
        sync: false
      }
    },
    line_linked: {
      enable: true,
      distance: 110,
      color: "#33b1f8",
      opacity: 0.25,
      width: 1
    },
    move: {
      enable: true,
      speed: 1.6,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200
      }
    }
  },
  interactivity: {
    detect_on: "canvas",
    events: {
      onhover: {
        enable: false,
        mode: "repulse"
      },
      onclick: {
        enable: false,
        mode: "push"
      },
      resize: true
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 1
        }
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
        speed: 3
      },
      repulse: {
        distance: 200,
        duration: 0.4
      },
      push: {
        particles_nb: 4
      },
      remove: {
        particles_nb: 2
      }
    }
  },
  retina_detect: true

        }}
      />
      </div>
      
      <Greeting />
      <Apod />
      {/* <Birthday /> */}
      <Earth />
      <Donki />

      {/* <iframe src='https://mars.nasa.gov/layout/embed/image/insightweather/'
       width='300' height='530'  ></iframe> */}

       <Gallary />
       <Feedback />
       {/* <Slider /> */}
       <Contact />
      
    </div>
    </CounterContextProider>
  );
}

export default Home;
